import { Head, Link, router } from "@inertiajs/react"
import { Box, Button, Container, Stack, Typography } from "@mui/material"

type Props = {
  user: { id: number; email: string; system_admin: boolean }
}

export default function Home({ user }: Props) {
  const signOut = () => {
    router.delete("/users/sign_out")
  }

  return (
    <>
      <Head title="Okonomi JP" />
      <Container maxWidth="md" sx={{ py: 6 }} data-testid="home-page">
        <Box>
          <Typography variant="h3" component="h1" gutterBottom>
            Okonomi JP
          </Typography>
          <Typography variant="body1" gutterBottom>
            Signed in as <strong>{user.email}</strong>.
          </Typography>
          <Stack direction="row" gap={2} sx={{ mt: 2 }}>
            {user.system_admin && (
              <Button variant="contained" component={Link} href="/admin/topics" data-testid="admin-link">
                Admin
              </Button>
            )}
            <Button variant="outlined" onClick={signOut}>
              Sign out
            </Button>
          </Stack>
        </Box>
      </Container>
    </>
  )
}
